import React, {Component} from "react";
import {FormattedMessage, FormattedNumber, injectIntl} from "react-intl";
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";
import MoneyInputForm from "../../common/form/moneyinput.component.jsx";
import Checkbox from "../../common/checkbox/checkbox.component.jsx";
import StandardList from "../../common/listing/list.component.jsx";
import Icon from "../../common/icon/icon.component.jsx";
import ActionButton from "../../common/button/actionbutton.component.jsx";

class ReceivePaymentDocuments extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            amount: 0,
            documentPayments: [],
            dueDocuments: [],
            isLoading: true,
            contactName: this.props.contactName || '',
            currency: '',
            currentBalance: this.props.currentBalance || 0,
            contactId: this.props.contactId || '',
            documentType: this.props.documentType || 'invoices',
        }
        this.loadDocumentsByContactId = this.loadDocumentsByContactId.bind(this)
        this.setDocumentAmount = this.setDocumentAmount.bind(this)
        this.getTotalAmount = this.getTotalAmount.bind(this)
        this.checkDocument = this.checkDocument.bind(this)
        this.checkAllDocuments = this.checkAllDocuments.bind(this)
        this.onCreatePaymentCart = this.onCreatePaymentCart.bind(this)
        this.isDisabled = this.isDisabled.bind(this)
    }

    componentDidMount() {
        if (this.state.contactId) {
            this.loadDocumentsByContactId()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.documentType !== prevProps.documentType) {
            this.setState({
                isLoading: true,
                documentType: this.props.documentType
            }, () => this.loadDocumentsByContactId())
        }
    }

    loadDocumentsByContactId() {
        const endpoint = `/customer-accounts/${this.state.contactId}/due-${this.state.documentType}`
        let currentBalance = 0
        AppContext.getApiClient().get(endpoint).then(res => {
            if (res.error) {
                return
            }
            const payments = res.data.map(doc => {
                currentBalance = currentBalance + parseFloat(this.getBalanceFromType(doc))
                return {
                    documentId: doc.id,
                    currency: doc.currency,
                    checked: false,
                    amount: this.getBalanceFromType(doc),
                    balance: this.getBalanceFromType(doc),
                    isBlocked: false
                }
            })
            this.setState({
                isLoading: false,
                dueDocuments: res.data.filter(doc => this.getBalanceFromType(doc) > 0),
                documentPayments: payments,
                amount: this.getTotalAmount(payments),
                currentBalance: currentBalance.toFixed(2),
                currency: res.data && res.data.length > 0 ? res.data[0].currency : ''
            })
        })
    }

    getBalanceFromType(doc) {
        switch (this.state.documentType) {
            case "invoices":
                return parseFloat(doc.balance).toFixed(2)
            default:
                return parseFloat(doc.depositBalance).toFixed(2)
        }
    }

    setDocumentAmount(documentId, amount) {
        let amounts = this.state.documentPayments.map(pay => {
            if (pay.documentId === documentId) {
                pay.amount = parseFloat(amount)
            }
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            documentPayments: amounts,
            amount: totalAmount,
        })
    }

    getTotalAmount(payments) {
        return payments
            .filter(pay => pay.checked)
            .reduce((accumulator, pay) => accumulator + (parseFloat(pay.amount) || 0), 0)
    }

    checkDocument(documentId, isChecked) {
        let amounts = this.state.documentPayments.map(pay => {
            if (pay.documentId === documentId) {
                pay.checked = isChecked
                isChecked ? pay.amount = pay.balance : pay.amount = 0
            } else if (this.isDisabled()) {
                pay.checked = false
                isChecked ? pay.amount = pay.balance : pay.amount = 0
            }
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            documentPayments: amounts,
            amount: totalAmount,
        })
    }

    checkAllDocuments(isChecked) {
        let amounts = this.state.documentPayments.map(pay => {
            pay.checked = isChecked && !pay.isBlocked
            isChecked && !pay.isBlocked ? pay.amount = pay.balance : pay.amount = 0
            return pay
        })
        const totalAmount = this.getTotalAmount(amounts)

        this.setState({
            documentPayments: amounts,
            amount: totalAmount,
        })
    }

    row(document) {
        let rows = [
            <span>
                {document.identifier}
                <small className="ml-2">{document.poNumber}</small>
            </span>,
        ]
        const checked = this.isDocumentChecked(document.id)
        rows = rows.concat([
            <FormattedNumber
                style="currency"
                currency={document.currency}
                value={this.getBalanceFromType(document)}
            />,
            <MoneyInputForm
                key={document.id}
                id={'amount_' + document.id}
                currency={document.currency}
                max={this.getBalanceFromType(document)}
                value={checked ? this.getDocumentAmount(document.id) : 0}
                onChange={val => {
                    this.setDocumentAmount(document.id, val)
                }}
                onBlur={val => {
                    this.setDocumentAmount(document.id, val)
                }}
                inputClassName={'text-right'}
                debounced={true}
                debounceTimeout={2000}
                disabled={!checked}
            />,
            <Checkbox checked={checked} onChange={isChecked => {
                this.checkDocument(document.id, isChecked)
            }}/>,
        ])
        return {
            className: checked ? '' : 'bg-light',
            data: rows,
        }
    }

    headers() {
        let checkbox = !this.isDisabled() ?
            <Checkbox checked={this.isAllChecked()} onChange={this.checkAllDocuments}/> :
            ''

        let headers = [
            <FormattedMessage
                id="customers.invoices.list.headers.id_label"
                defaultMessage="ID"
            />,
        ]
        headers = headers.concat([
            this.state.documentType === 'invoices' ?
                <FormattedMessage
                    id="customers.invoices.list.headers.balance_label"
                    defaultMessage="Balance"
                /> :
                <FormattedMessage
                    id="customers.invoices.list.headers.deposit_balance_label"
                    defaultMessage="Deposit balance"
                />,
            <FormattedMessage
                id="customers.invoices.list.headers.pay_amount_label"
                defaultMessage="Pay amount"
            />,
            checkbox,
        ])
        return headers
    }

    isDisabled() {
        return this.state.documentType === "orders" || this.state.documentType === "quotes"
    }

    isAllChecked() {
        return this.state.documentPayments.length === this.state.documentPayments
            .filter(pay => pay.checked || pay.isBlocked).length
    }

    getDocumentAmount(documentId) {
        const pay = this.state.documentPayments.find(pay => pay.documentId === documentId)
        return pay ? pay.amount : 0
    }

    isDocumentChecked(documentId) {
        const pay = this.state.documentPayments.find(pay => pay.documentId === documentId)
        return pay ? pay.checked : false
    }

    onCreatePaymentCart() {
        this.props.onCreatePaymentCart(this.state.dueDocuments, this.state.documentPayments, this.state.amount)
    }

    render() {
        let newBalance = (this.state.currentBalance - this.state.amount).toFixed(2)

        return <div>
            {!this.state.isLoading &&
            <StandardList
                smallLine={true}
                className="row pt-0"
                headers={this.headers()}
                rows={this.state.dueDocuments.map(doc => this.row(doc))}
            />}
            <div className="form-group row mt-2 mb-0 justify-content-end">
                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                    <FormattedMessage
                        id="invoice.receive_payment.balance_label"
                        defaultMessage="Current balance"
                    />
                </label>
                <div className="col-1">
                </div>
                <div className="col-2">
                    <div className="input-group mb-0 py-1 text-right justify-content-end">
                        <strong>
                            <FormattedNumber
                                value={this.state.currentBalance}
                                currency={this.state.currency}
                                style={'currency'}
                            />
                        </strong>
                    </div>
                </div>
            </div>


            <div className="form-group row mb-0 justify-content-end">
                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                    <FormattedMessage
                        id="invoice.receive_payment.payment_label"
                        defaultMessage="Payment"
                    />
                </label>
                <div className="col-1 d-flex align-items-center justify-content-end">
                    <Icon value={'minus'}/>
                </div>
                <div className="col-2">
                    <div className="input-group mb-0 py-1 text-right justify-content-end">
                        <strong>
                            <FormattedNumber
                                value={this.state.amount}
                                currency={this.state.currency}
                                style={'currency'}
                            />
                        </strong>
                    </div>
                </div>
            </div>


            <div className="form-group row mb-1 justify-content-end">
                <label className="col-3 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                    <FormattedMessage
                        id="invoice.receive_payment.new_balance_label"
                        defaultMessage="New balance"
                    />
                </label>
                <div className="col-1 d-flex align-items-center justify-content-end">
                    <Icon value={'equals'}/>
                </div>
                <div className="col-2">
                    <div className="input-group mb-0 py-1 justify-content-end">
                        <strong>
                            <FormattedNumber
                                value={newBalance}
                                currency={this.state.currency}
                                style={'currency'}
                            />
                        </strong>
                    </div>
                </div>
            </div>

            <ActionButton
                disabled={!(this.state.amount > 0)}
                className={"btn btn-primary btn-lg btn-block mt-4"}
                isLoading={this.state.isLoading}
                onClick={this.onCreatePaymentCart}
            >
                <FormattedMessage
                    id="invoice.receive_payment.apply_payment_btn"
                    defaultMessage="Apply payment"
                />
            </ActionButton>
        </div>
    }
}

export default injectIntl(ReceivePaymentDocuments);



// WEBPACK FOOTER //
// ./src/embed/shopify/receivePaymentDocuments.component.jsx